export const UPLOADING_MEDIA_PREFIX = "uploading://";

const escapeXml = (value: string) => value.replace(/[<>&"']/g, (char) => `&#${char.charCodeAt(0)};`);

const fileNameOf = (source: string) => {
  const name = decodeURIComponent(source.split(/[?#]/)[0].split("/").pop() ?? "");
  return escapeXml(name.length > 48 ? `${name.slice(0, 45)}…` : name);
};

const toDataUrl = (svg: string) => `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;

export const uploadingSource = (file: File) => `${UPLOADING_MEDIA_PREFIX}${crypto.randomUUID()}/${encodeURIComponent(file.name)}`;

export const isUploadingSource = (source?: string) => Boolean(source?.startsWith(UPLOADING_MEDIA_PREFIX));

export const hasPendingUploads = (markdown: string) => markdown.includes(`](${UPLOADING_MEDIA_PREFIX}`);

export const uploadingFileName = (source: string) => decodeURIComponent(source.split("/").pop() ?? "");

export const uploadingPlaceholder = (source: string) =>
  toDataUrl(`<svg xmlns="http://www.w3.org/2000/svg" width="640" height="120" viewBox="0 0 640 120">
<rect x="1" y="1" width="638" height="118" rx="14" fill="#f7fbea" stroke="#b5d66a" stroke-dasharray="6 5"/>
<g transform="translate(46 60)">
<circle r="14" fill="none" stroke="#dcebb4" stroke-width="4"/>
<path d="M 0 -14 A 14 14 0 0 1 14 0" fill="none" stroke="#99c32c" stroke-width="4" stroke-linecap="round">
<animateTransform attributeName="transform" type="rotate" from="0" to="360" dur="0.9s" repeatCount="indefinite"/>
</path>
</g>
<text x="80" y="55" fill="#1a2b45" font-family="Inter, Arial, sans-serif" font-size="16" font-weight="600">Enviando…</text>
<text x="80" y="78" fill="#6b7a90" font-family="Inter, Arial, sans-serif" font-size="14">${fileNameOf(source)}</text>
</svg>`);

export const videoPlaceholder = (source: string) =>
  toDataUrl(`<svg xmlns="http://www.w3.org/2000/svg" width="640" height="200" viewBox="0 0 640 200">
<rect width="640" height="200" rx="16" fill="#1a2b45"/>
<circle cx="320" cy="84" r="34" fill="#99c32c"/>
<path d="M309 66 L339 84 L309 102 Z" fill="#1a2b45"/>
<text x="320" y="150" fill="#ffffff" font-family="Inter, Arial, sans-serif" font-size="18" font-weight="600" text-anchor="middle">Vídeo</text>
<text x="320" y="176" fill="#adb7d3" font-family="Inter, Arial, sans-serif" font-size="14" text-anchor="middle">${fileNameOf(source) || "vídeo"}</text>
</svg>`);
